const correctSound = new Audio("/correct.wav");
import React, { useState, useEffect } from "react";
import confetti from "canvas-confetti"; // keep this for the game confetti
const topics = [
  "Greetings",
  "Feelings",
  "School Vocabulary",
  "Daily Activities",
  "Family",
  "Food & Drinks",
  "Numbers & Time",
  "Colors & Shapes",
  "Animals",
  "Weather & Seasons",
  "Clothing",
  "Body Parts & Health",
  "Places Around Town",
  "Transportation",
];

// Words per topic (can expand later)
const topicWords = {
  Greetings: [
    { word: "Hello", meaning: "Halo" },
    { word: "Good morning", meaning: "Selamat pagi" },
    { word: "Good afternoon", meaning: "Selamat siang" },
    { word: "Good night", meaning: "Selamat malam" },
    { word: "How are you?", meaning: "Apa kabar?" },
    { word: "I'm fine", meaning: "Saya baik-baik saja" },
    { word: "Nice to meet you", meaning: "Senang bertemu denganmu" },
    { word: "See you later", meaning: "Sampai jumpa nanti" },
    { word: "See you tomorrow", meaning: "Sampai jumpa besok" },
    { word: "Goodbye", meaning: "Selamat tinggal" },
    { word: "Take care", meaning: "Hati-hati" },
    { word: "Welcome", meaning: "Selamat datang" },
    { word: "Excuse me", meaning: "Permisi" },
    { word: "Sorry", meaning: "Maaf" },
    { word: "Thank you", meaning: "Terima kasih" },
    { word: "You're welcome", meaning: "Sama-sama" },
    { word: "What's your name?", meaning: "Siapa namamu?" },
    { word: "My name is Miss Allie", meaning: "Nama saya Miss Allie" },
  ],
  Feelings: [
    { word: "Happy", meaning: "Senang" },
    { word: "Sad", meaning: "Sedih" },
    { word: "Angry", meaning: "Marah" },
    { word: "Excited", meaning: "Bersemangat" },
    { word: "Tired", meaning: "Lelah" },
    { word: "Hungry", meaning: "Lapar" },
    { word: "Thirsty", meaning: "Haus" },
    { word: "Scared", meaning: "Takut" },
    { word: "Surprised", meaning: "Terkejut" },
    { word: "Nervous", meaning: "Gugup" },
    { word: "Proud", meaning: "Bangga" },
    { word: "Bored", meaning: "Bosan" },
    { word: "Confused", meaning: "Bingung" },
    { word: "Sleepy", meaning: "Mengantuk" },
    { word: "Sick", meaning: "Sakit" },
    { word: "Cold", meaning: "Kedinginan" },
    { word: "Hot", meaning: "Kepanasan" },
    { word: "Calm", meaning: "Tenang" },
    { word: "Shy", meaning: "Malu" },
    { word: "Brave", meaning: "Berani" },
  ],
  "School Vocabulary": [
    { word: "Teacher", meaning: "Guru" },
    { word: "Student", meaning: "Siswa" },
    { word: "Classroom", meaning: "Kelas" },
    { word: "School", meaning: "Sekolah" },
    { word: "Book", meaning: "Buku" },
    { word: "Notebook", meaning: "Buku tulis" },
    { word: "Pen", meaning: "Pulpen" },
    { word: "Pencil", meaning: "Pensil" },
    { word: "Eraser", meaning: "Penghapus" },
    { word: "Bag", meaning: "Tas" },
    { word: "Desk", meaning: "Meja" },
    { word: "Chair", meaning: "Kursi" },
    { word: "Board", meaning: "Papan tulis" },
    { word: "Homework", meaning: "PR" },
    { word: "Test", meaning: "Ujian" },
  ],
  "Daily Activities": [
    { word: "Wake up", meaning: "Bangun tidur" },
    { word: "Brush teeth", meaning: "Sikat gigi" },
    { word: "Take a shower", meaning: "Mandi" },
    { word: "Eat breakfast", meaning: "Sarapan" },
    { word: "Go to school", meaning: "Pergi ke sekolah" },
    { word: "Study", meaning: "Belajar" },
    { word: "Play", meaning: "Bermain" },
    { word: "Eat lunch", meaning: "Makan siang" },
    { word: "Go home", meaning: "Pulang" },
    { word: "Eat dinner", meaning: "Makan malam" },
    { word: "Watch TV", meaning: "Menonton TV" },
    { word: "Read a book", meaning: "Membaca buku" },
    { word: "Sleep", meaning: "Tidur" },
  ],
  Family: [
    { word: "Father", meaning: "Bapak" },
    { word: "Mother", meaning: "Ibu" },
    { word: "Parents", meaning: "Orang tua" },
    { word: "Brother", meaning: "Saudara laki-laki" },
    { word: "Sister", meaning: "Saudara perempuan" },
    { word: "Grandfather", meaning: "Kakek" },
    { word: "Grandmother", meaning: "Nenek" },
    { word: "Uncle", meaning: "Paman" },
    { word: "Aunt", meaning: "Tante" },
    { word: "Cousin", meaning: "Sepupu" },
    { word: "Baby", meaning: "Bayi" },
  ],
  "Food & Drinks": [
    { word: "Rice", meaning: "Nasi" },
    { word: "Chicken", meaning: "Ayam" },
    { word: "Fish", meaning: "Ikan" },
    { word: "Egg", meaning: "Telur" },
    { word: "Bread", meaning: "Roti" },
    { word: "Noodles", meaning: "Mie" },
    { word: "Soup", meaning: "Sup" },
    { word: "Vegetables", meaning: "Sayuran" },
    { word: "Fruit", meaning: "Buah" },
    { word: "Water", meaning: "Air" },
    { word: "Milk", meaning: "Susu" },
    { word: "Juice", meaning: "Jus" },
    { word: "Tea", meaning: "Teh" },
    { word: "Coffee", meaning: "Kopi" },
  ],
  "Numbers & Time": [
    { word: "One", meaning: "Satu" },
    { word: "Two", meaning: "Dua" },
    { word: "Three", meaning: "Tiga" },
    { word: "Four", meaning: "Empat" },
    { word: "Five", meaning: "Lima" },
    { word: "Six", meaning: "Enam" },
    { word: "Seven", meaning: "Tujuh" },
    { word: "Eight", meaning: "Delapan" },
    { word: "Nine", meaning: "Sembilan" },
    { word: "Ten", meaning: "Sepuluh" },
    { word: "Hundred", meaning: "Ratus" },
    { word: "Thousand", meaning: "Ribu" },
    { word: "Morning", meaning: "Pagi" },
    { word: "Afternoon", meaning: "Siang" },
    { word: "Evening", meaning: "Sore" },
    { word: "Night", meaning: "Malam" },
    { word: "Today", meaning: "Hari ini" },
    { word: "Tomorrow", meaning: "Besok" },
    { word: "Yesterday", meaning: "Kemarin" },
    { word: "Two weeks ago", meaning: "Dua minggu lalu" },
    { word: "Last month", meaning: "Bulan lalu" },
    { word: "Next year", meaning: "Tahun depan" },
  ],
  "Colors & Shapes": [
    { word: "Red", meaning: "Merah" },
    { word: "Blue", meaning: "Biru" },
    { word: "Yellow", meaning: "Kuning" },
    { word: "Green", meaning: "Hijau" },
    { word: "Black", meaning: "Hitam" },
    { word: "White", meaning: "Putih" },
    { word: "Brown", meaning: "Cokelat" },
    { word: "Pink", meaning: "Merah muda" },
    { word: "Purple", meaning: "Ungu" },
    { word: "Orange", meaning: "Oranye" },
    { word: "Circle", meaning: "Lingkaran" },
    { word: "Square", meaning: "Persegi" },
    { word: "Triangle", meaning: "Segitiga" },
    { word: "Rectangle", meaning: "Persegi panjang" },
    { word: "Star", meaning: "Bintang" },
    { word: "Heart", meaning: "Bentuk hati" },
    { word: "Diamond", meaning: "Belah ketupat" },
    { word: "Oval", meaning: "Oval" },
    { word: "Big", meaning: "Besar" },
    { word: "Small", meaning: "Kecil" },
  ],

  Animals: [
    { word: "Cat", meaning: "Kucing" },
    { word: "Dog", meaning: "Anjing" },
    { word: "Bird", meaning: "Burung" },
    { word: "Fish", meaning: "Ikan" },
    { word: "Rabbit", meaning: "Kelinci" },
    { word: "Cow", meaning: "Sapi" },
    { word: "Goat", meaning: "Kambing" },
    { word: "Chicken", meaning: "Ayam" },
    { word: "Duck", meaning: "Bebek" },
    { word: "Horse", meaning: "Kuda" },
    { word: "Elephant", meaning: "Gajah" },
    { word: "Monkey", meaning: "Monyet" },
    { word: "Tiger", meaning: "Harimau" },
    { word: "Lion", meaning: "Singa" },
    { word: "Bear", meaning: "Beruang" },
    { word: "Snake", meaning: "Ular" },
    { word: "Frog", meaning: "Katak" },
    { word: "Butterfly", meaning: "Kupu-kupu" },
    { word: "Bee", meaning: "Lebah" },
    { word: "Turtle", meaning: "Kura-kura" },
  ],

  "Weather & Seasons": [
    { word: "Sunny", meaning: "Cerah" },
    { word: "Rainy", meaning: "Hujan" },
    { word: "Cloudy", meaning: "Berawan" },
    { word: "Windy", meaning: "Berangin" },
    { word: "Storm", meaning: "Badai" },
    { word: "Thunder", meaning: "Guntur" },
    { word: "Lightning", meaning: "Petir" },
    { word: "Rainbow", meaning: "Pelangi" },
    { word: "Hot", meaning: "Panas" },
    { word: "Cold", meaning: "Dingin" },
    { word: "Spring", meaning: "Musim semi" },
    { word: "Summer", meaning: "Musim panas" },
    { word: "Autumn", meaning: "Musim gugur" },
    { word: "Winter", meaning: "Musim dingin" },
    { word: "Morning", meaning: "Pagi" },
    { word: "Afternoon", meaning: "Siang" },
    { word: "Evening", meaning: "Sore" },
    { word: "Night", meaning: "Malam" },
    { word: "Sky", meaning: "Langit" },
    { word: "Sun", meaning: "Matahari" },
  ],

  Clothing: [
    { word: "Shirt", meaning: "Kemeja" },
    { word: "T-shirt", meaning: "Kaos" },
    { word: "Pants", meaning: "Celana panjang" },
    { word: "Shorts", meaning: "Celana pendek" },
    { word: "Skirt", meaning: "Rok" },
    { word: "Dress", meaning: "Gaun" },
    { word: "Jacket", meaning: "Jaket" },
    { word: "Sweater", meaning: "Sweater" },
    { word: "Shoes", meaning: "Sepatu" },
    { word: "Socks", meaning: "Kaus kaki" },
    { word: "Hat", meaning: "Topi" },
    { word: "Scarf", meaning: "Syal" },
    { word: "Belt", meaning: "Ikat pinggang" },
    { word: "Uniform", meaning: "Seragam" },
    { word: "Gloves", meaning: "Sarung tangan" },
    { word: "Sandals", meaning: "Sandal" },
    { word: "Pocket", meaning: "Saku" },
    { word: "Button", meaning: "Kancing" },
    { word: "Zipper", meaning: "Ritsleting" },
  ],

  "Body Parts & Health": [
    { word: "Head", meaning: "Kepala" },
    { word: "Hair", meaning: "Rambut" },
    { word: "Eye", meaning: "Mata" },
    { word: "Ear", meaning: "Telinga" },
    { word: "Nose", meaning: "Hidung" },
    { word: "Mouth", meaning: "Mulut" },
    { word: "Teeth", meaning: "Gigi" },
    { word: "Hand", meaning: "Tangan" },
    { word: "Finger", meaning: "Jari" },
    { word: "Arm", meaning: "Lengan" },
    { word: "Leg", meaning: "Kaki" },
    { word: "Foot", meaning: "Telapak kaki" },
    { word: "Knee", meaning: "Lutut" },
    { word: "Back", meaning: "Punggung" },
    { word: "Stomach", meaning: "Perut" },
    { word: "Healthy", meaning: "Sehat" },
    { word: "Sick", meaning: "Sakit" },
    { word: "Medicine", meaning: "Obat" },
    { word: "Doctor", meaning: "Dokter" },
    { word: "Nurse", meaning: "Perawat" },
  ],

  "Places Around Town": [
    { word: "School", meaning: "Sekolah" },
    { word: "Library", meaning: "Perpustakaan" },
    { word: "Hospital", meaning: "Rumah sakit" },
    { word: "Pharmacy", meaning: "Apotek" },
    { word: "Bank", meaning: "Bank" },
    { word: "Post Office", meaning: "Kantor pos" },
    { word: "Restaurant", meaning: "Restoran" },
    { word: "Café", meaning: "Kafe" },
    { word: "Market", meaning: "Pasar" },
    { word: "Park", meaning: "Taman" },
    { word: "Beach", meaning: "Pantai" },
    { word: "Airport", meaning: "Bandara" },
    { word: "Bus Station", meaning: "Terminal bus" },
    { word: "Train Station", meaning: "Stasiun kereta" },
    { word: "Police Station", meaning: "Kantor polisi" },
    { word: "Fire Station", meaning: "Pos pemadam kebakaran" },
    { word: "Mosque", meaning: "Masjid" },
    { word: "Church", meaning: "Gereja" },
  ],

  Transportation: [
    { word: "Car", meaning: "Mobil" },
    { word: "Motorcycle", meaning: "Sepeda motor" },
    { word: "Bicycle", meaning: "Sepeda" },
    { word: "Bus", meaning: "Bus" },
    { word: "Train", meaning: "Kereta api" },
    { word: "Airplane", meaning: "Pesawat" },
    { word: "Boat", meaning: "Perahu" },
    { word: "Ship", meaning: "Kapal" },
    { word: "Taxi", meaning: "Taksi" },
    { word: "Truck", meaning: "Truk" },
    { word: "Helmet", meaning: "Helm" },
    { word: "Road", meaning: "Jalan" },
    { word: "Traffic Light", meaning: "Lampu lalu lintas" },
    { word: "Bridge", meaning: "Jembatan" },
    { word: "Ticket", meaning: "Tiket" },
    { word: "Driver", meaning: "Pengemudi" },
    { word: "Passenger", meaning: "Penumpang" },
    { word: "Stop", meaning: "Berhenti" },
    { word: "Go", meaning: "Pergi" },
  ],
};

export default function App() {
  const [selectedTopic, setSelectedTopic] = useState(null);
  const [mode, setMode] = useState(null);
  const [streak, setStreak] = useState(0);

  useEffect(() => {
    const lastVisit = localStorage.getItem("lastVisit");
    const today = new Date().toLocaleDateString("en-CA", {
      timeZone: "Asia/Jakarta",
    });

    if (lastVisit !== today) {
      const newStreak = (parseInt(localStorage.getItem("streak")) || 0) + 1;
      setStreak(newStreak);
      localStorage.setItem("lastVisit", today);
      localStorage.setItem("streak", newStreak);
    } else {
      const savedStreak = localStorage.getItem("streak");
      if (savedStreak) setStreak(parseInt(savedStreak));
    }
  }, []);
  useEffect(() => {
    speechSynthesis.getVoices();
  }, []);

  const speak = (text, lang = "en-US") => {
    const utterance = new SpeechSynthesisUtterance(text);

    const voices = speechSynthesis.getVoices();

    const selectedVoice = voices.find((voice) =>
      lang === "id-ID"
        ? voice.lang.toLowerCase().includes("id")
        : voice.lang.toLowerCase().includes("en")
    );

    if (selectedVoice) {
      utterance.voice = selectedVoice;
    }

    utterance.lang = lang;
    speechSynthesis.speak(utterance);
  };

  return (
    <div style={styles.page}>
      {!selectedTopic && (
        <>
          <div style={styles.header}>
            <img
              src="/mascot.png"
              alt="Bahasafun Mascot"
              style={styles.mascot}
            />
            <h1 style={styles.title}>BAHASA FUN</h1>
            <p style={styles.subtitle}>Learn English with Miss Allie</p>
          </div>

          <div style={styles.streakBox}>🔥 Daily Streak: {streak}</div>

          <h2 style={{ marginTop: 30 }}>Choose a Topic</h2>

          <div style={styles.topicContainer}>
            {topics.map((topic, index) => (
              <button
                key={index}
                style={styles.topicBubble}
                onClick={() => setSelectedTopic(topic)}
              >
                {topic}
              </button>
            ))}
          </div>
        </>
      )}

      {selectedTopic && !mode && (
        <>
          <button style={styles.backBtn} onClick={() => setSelectedTopic(null)}>
            ← Home
          </button>

          <h2>{selectedTopic}</h2>

          <div style={styles.modeContainer}>
            <button
              style={styles.modeBtn}
              onClick={() => setMode("flashcards")}
            >
              📚 Flashcards
            </button>
            <button style={styles.modeBtn} onClick={() => setMode("memorize")}>
              🧠 Memorize
            </button>
            <button style={styles.modeBtn} onClick={() => setMode("games")}>
              🎮 Games
            </button>
          </div>
        </>
      )}

      {selectedTopic && mode === "flashcards" && (
        <Flashcards
          words={topicWords[selectedTopic] || []}
          goBack={() => setMode(null)}
          speak={speak}
        />
      )}

      {selectedTopic && mode === "memorize" && (
        <Memorize
          words={topicWords[selectedTopic] || []}
          goBack={() => setMode(null)}
        />
      )}

      {selectedTopic && mode === "games" && (
        <Games
          words={topicWords[selectedTopic] || []}
          goBack={() => setMode(null)}
        />
      )}
    </div>
  );
}

// FLASHCARDS COMPONENT (now properly separated)
function Flashcards({ words, goBack, speak }) {
  const [shuffledWords, setShuffledWords] = useState([]);
  const [index, setIndex] = useState(0);
  const [showMeaning, setShowMeaning] = useState(false);
  const [startWith, setStartWith] = useState("english");
  useEffect(() => {
    const shuffled = [...words].sort(() => Math.random() - 0.5);
    setShuffledWords(shuffled);
    setIndex(0);
    setShowMeaning(false);
  }, [words]);

  if (!words.length) {
    return (
      <>
        <button onClick={goBack} style={styles.backBtn}>
          ← Back
        </button>
        <p>No words added yet for this topic.</p>
      </>
    );
  }

  const current = shuffledWords[index] || {};

  const totalCards = shuffledWords.length;
  const currentCardNumber = index + 1;
  return (
    <>
      <button onClick={goBack} style={styles.backBtn}>
        ← Back
      </button>

      <div style={{ marginBottom: 15 }}>
        <button
          style={styles.smallBtn}
          onClick={() => {
            setStartWith("english");
            setShowMeaning(false);
          }}
        >
          Start with English
        </button>

        <button
          style={styles.smallBtn}
          onClick={() => {
            setStartWith("indonesian");
            setShowMeaning(false);
          }}
        >
          Start with Indonesian
        </button>
      </div>

      <p style={{ fontWeight: "bold", marginBottom: 10 }}>
        Card {currentCardNumber} of {totalCards}
      </p>
      <div style={styles.progressBar}>
        <div
          style={{
            ...styles.progressFill,
            width: `${(currentCardNumber / totalCards) * 100}%`,
          }}
        />
      </div>
      <div style={styles.card}>
        {!showMeaning && (
          <h2>{startWith === "english" ? current.word : current.meaning}</h2>
        )}

        {showMeaning && (
          <h2>{startWith === "english" ? current.meaning : current.word}</h2>
        )}

        {(showMeaning ? startWith !== "english" : startWith === "english") && (
          <button
            style={styles.smallBtn}
            onClick={() => speak(current.word, "en-US")}
          >
            🔊 Listen
          </button>
        )}
      </div>

      <button
        style={styles.smallBtn}
        onClick={() => setShowMeaning(!showMeaning)}
      >
        {showMeaning ? "Hide Meaning" : "Show Meaning"}
      </button>

      <div style={styles.row}>
        <button
          style={styles.smallBtn}
          onClick={() => {
            setIndex(
              (prev) => (prev - 1 + shuffledWords.length) % shuffledWords.length
            );
            setShowMeaning(false);
          }}
        >
          ← Previous
        </button>

        <button
          style={styles.smallBtn}
          onClick={() => {
            setIndex((prev) => (prev + 1) % shuffledWords.length);
            setShowMeaning(false);
          }}
        >
          Next →
        </button>
      </div>
    </>
  );
}
const shuffleWords = (array) => {
  const shuffled = [...array];

  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }

  return shuffled;
};
function Memorize({ words, goBack }) {
  const [activeWords, setActiveWords] = useState(() => shuffleWords(words));
  const [index, setIndex] = useState(0);
  const [answer, setAnswer] = useState("");
  const [feedback, setFeedback] = useState("");
  const [status, setStatus] = useState(null);
  const [finished, setFinished] = useState(false);
  const [score, setScore] = useState(0);

  const [missedWords, setMissedWords] = useState([]);
  const [reviewing, setReviewing] = useState(false);

  useEffect(() => {
    setActiveWords(shuffleWords(words));
    setIndex(0);
    setAnswer("");
    setFeedback("");
    setStatus(null);
    setFinished(false);
    setScore(0);
    setMissedWords([]);
    setReviewing(false);
  }, [words]);

  if (!activeWords.length) {
    return (
      <>
        <button onClick={goBack} style={styles.backBtn}>
          ← Back
        </button>
        <p>No words added yet for this topic.</p>
      </>
    );
  }

  const current = activeWords[index];

  const handleCheck = () => {
    if (status) return;

    const correct = answer.trim().toLowerCase() === current.word.toLowerCase();

    if (correct) {
      setStatus("correct");
      setFeedback("✔️ Correct!");
      setScore((prev) => prev + 1);
    } else {
      setStatus("wrong");
      setFeedback(`Correct answer: ${current.word}`);

      setMissedWords((prev) => {
        if (prev.some((w) => w.word === current.word)) return prev;
        return [...prev, current];
      });
    }

    const delay = correct ? 1000 : 3000;

    setTimeout(() => {
      if (index === activeWords.length - 1) {
        setFinished(true);
      } else {
        setIndex((prev) => prev + 1);
        setAnswer("");
        setFeedback("");
        setStatus(null);
      }
    }, delay);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") handleCheck();
  };

  const restart = () => {
    setActiveWords(shuffleWords(words));
    setIndex(0);
    setAnswer("");
    setFeedback("");
    setFinished(false);
    setScore(0);
    setStatus(null);
    setMissedWords([]);
    setReviewing(false);
  };

  const reviewMissedWords = () => {
    if (missedWords.length === 0) {
      confetti({
        particleCount: 150,
        spread: 70,
        origin: { y: 0.6 },
      });
      setFinished(true);
      return;
    }

    setActiveWords(shuffleWords(missedWords));
    setMissedWords([]);
    setReviewing(true);

    setIndex(0);
    setAnswer("");
    setFeedback("");
    setStatus(null);
    setScore(0);
    setFinished(false);
  };
  if (finished) {
    return (
      <div style={{ textAlign: "center", padding: 20 }}>
        <h2>{reviewing ? "🎉 Good job!" : "🎉 Well done!"}</h2>

        <img
          src="/mascot.png"
          alt="Bahasafun Brain Logo"
          style={{ width: 150, margin: "20px 0" }}
        />

        {reviewing ? (
          <>
            <p style={{ fontSize: 18, marginBottom: 10 }}></p>

            <p style={{ fontSize: 18, marginBottom: 20 }}>
              Score: {score} / {activeWords.length}
            </p>
          </>
        ) : (
          <p style={{ fontSize: 18, marginBottom: 20 }}>
            Your score: {score} / {activeWords.length}
          </p>
        )}

        {!reviewing && missedWords.length > 0 && (
          <button style={styles.smallBtn} onClick={reviewMissedWords}>
            Practice Missed Words
          </button>
        )}

        {(reviewing || missedWords.length === 0) && (
          <button style={styles.smallBtn} onClick={restart}>
            Try Again
          </button>
        )}

        <button style={styles.smallBtn} onClick={goBack}>
          ← Back to Menu
        </button>
      </div>
    );
  }

  return (
    <>
      <button onClick={goBack} style={styles.backBtn}>
        ← Back
      </button>

      <h2>Memorize</h2>

      <p style={{ fontWeight: "bold", marginBottom: 10 }}>
        Card {index + 1} of {activeWords.length}
      </p>

      <div style={styles.progressBar}>
        <div
          style={{
            ...styles.progressFill,
            width: `${((index + 1) / activeWords.length) * 100}%`,
          }}
        />
      </div>

      <div
        style={{
          ...styles.card,
          animation: status === "wrong" ? "shake 0.3s" : "",
        }}
      >
        <h2>{current.meaning}</h2>
      </div>

      <input
        type="text"
        value={answer}
        onChange={(e) => setAnswer(e.target.value)}
        onKeyDown={handleKeyPress}
        placeholder="Type the English word"
        style={{
          padding: 10,
          borderRadius: 10,
          border: "1px solid #ccc",
          marginTop: 10,
          width: "60%",
          textAlign: "center",
        }}
      />

      <div style={styles.row}>
        <button
          style={{
            ...styles.choiceBtn,
            backgroundColor:
              status === "correct"
                ? "lightgreen"
                : status === "wrong"
                ? "#f88379"
                : "",
          }}
          onClick={handleCheck}
        >
          Check
        </button>

        <button
          style={styles.smallBtn}
          onClick={() => {
            if (index === activeWords.length - 1) {
              setFinished(true);
            } else {
              setIndex((prev) => prev + 1);
              setAnswer("");
              setFeedback("");
              setStatus(null);
            }
          }}
        >
          Next →
        </button>
      </div>

      {feedback && <p style={{ marginTop: 10 }}>{feedback}</p>}

      <style>
        {`
          @keyframes shake {
            0% { transform: translateX(0px); }
            25% { transform: translateX(-5px); }
            50% { transform: translateX(5px); }
            75% { transform: translateX(-5px); }
            100% { transform: translateX(0px); }
          }
        `}
      </style>
    </>
  );
}
function Games({ words, goBack }) {
  const [index, setIndex] = useState(0);
  const [options, setOptions] = useState([]);
  const [score, setScore] = useState(0);
  const [mode, setMode] = useState("english");
  const [isFinished, setIsFinished] = useState(false);
  const [clickedIndex, setClickedIndex] = useState(null);
  const [correctIndex, setCorrectIndex] = useState(null);

  if (!words.length) {
    return (
      <>
        <button onClick={goBack} style={styles.backBtn}>
          ← Back
        </button>
        <p>No words added yet for this topic.</p>
      </>
    );
  }

  const current = words[index];

  useEffect(() => {
    if (!isFinished) generateOptions();
    setClickedIndex(null);
  }, [index, mode, isFinished]);

  const generateOptions = () => {
    const correctOption = { word: current.word, meaning: current.meaning };
    const otherWords = words.filter((w) => w.word !== current.word);
    const shuffled = otherWords.sort(() => 0.5 - Math.random());
    const wrongOptions = shuffled.slice(0, Math.min(2, shuffled.length));
    const allOptions = [...wrongOptions, correctOption].sort(
      () => 0.5 - Math.random()
    );
    setOptions(allOptions);

    setCorrectIndex(
      allOptions.findIndex((o) =>
        mode === "english"
          ? o.meaning === current.meaning
          : o.word === current.word
      )
    );
  };

  const handleAnswer = (option, i) => {
    if (clickedIndex !== null) return;
    setClickedIndex(i);

    const correct =
      mode === "english"
        ? option.meaning === current.meaning
        : option.word === current.word;

    if (correct) {
      setScore((prev) => prev + 1);

      // 🔊 play sound
      correctSound.currentTime = 0;
      correctSound.play();
    } else {
      // 📳 vibrate on wrong
      if (navigator.vibrate) {
        navigator.vibrate([100, 50, 100]);
      }
    }

    setTimeout(() => {
      if (index + 1 >= words.length) {
        // 🎉 CONFETTI BOOM
        confetti({
          particleCount: 150,
          spread: 70,
          origin: { y: 0.6 },
        });
        setIsFinished(true);
      } else {
        setIndex((prev) => prev + 1);
      }
    }, 1000);
  };

  const restartGame = () => {
    setIndex(0);
    setScore(0);
    setIsFinished(false);
    setClickedIndex(null);
  };

  if (isFinished) {
    return (
      <div style={{ textAlign: "center", padding: 20 }}>
        <h2>🎉 Well done!</h2>

        {/* Bahasafun brain logo */}
        <img
          src="/mascot.png"
          alt="Bahasafun Brain Logo"
          style={{ width: 150, margin: "20px 0" }}
        />

        <p style={{ fontSize: 18, marginBottom: 20 }}>
          Your final score: {score} / {words.length}
        </p>

        <button style={styles.smallBtn} onClick={restartGame}>
          Try Again
        </button>

        <button style={styles.smallBtn} onClick={goBack}>
          ← Back to Menu
        </button>
      </div>
    );
  }

  return (
    <>
      <button onClick={goBack} style={styles.backBtn}>
        ← Back
      </button>

      <h2>🎮 Guess the Meaning</h2>

      <div style={{ marginBottom: 10 }}>
        <button style={styles.smallBtn} onClick={() => setMode("english")}>
          English → Indonesian
        </button>
        <button style={styles.smallBtn} onClick={() => setMode("indonesian")}>
          Indonesian → English
        </button>
      </div>

      <p>
        Score: {score} / {words.length}
      </p>

      <div style={styles.card}>
        <h2>{mode === "english" ? current.word : current.meaning}</h2>
      </div>

      <div style={{ marginTop: 20 }}>
        {options.map((option, i) => {
          let bgColor = "";
          let animation = "";

          if (clickedIndex !== null) {
            if (i === correctIndex) {
              bgColor = "lightgreen";
            } else if (i === clickedIndex && clickedIndex !== correctIndex) {
              bgColor = "#f88379"; // red
              animation = "shake 0.3s";
            }
          }

          return (
            <button
              key={i}
              style={{
                ...styles.choiceBtn,
                backgroundColor: bgColor,
                animation,
              }}
              onClick={() => handleAnswer(option, i)}
            >
              {mode === "english" ? option.meaning : option.word}
            </button>
          );
        })}
      </div>

      <style>
        {`
          @keyframes shake {
            0% { transform: translateX(0px); }
            25% { transform: translateX(-5px); }
            50% { transform: translateX(5px); }
            75% { transform: translateX(-5px); }
            100% { transform: translateX(0px); }
          }
        `}
      </style>
    </>
  );
}
const styles = {
  page: {
    fontFamily: "Arial, sans-serif",
    backgroundColor: "#FFF6E9",
    minHeight: "100vh",
    padding: 30,
    textAlign: "center",
  },
  header: { marginBottom: 20 },
  mascot: { width: 220, marginBottom: 15 },
  title: { fontSize: "2.5rem", margin: 0, color: "#3A3A3A" },
  subtitle: { color: "#777", marginTop: 5 },
  streakBox: {
    marginTop: 15,
    background: "#FFE3C2",
    padding: 10,
    borderRadius: 20,
    display: "inline-block",
    fontWeight: "bold",
  },
  topicContainer: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: 15,
    marginTop: 20,
  },
  topicBubble: {
    padding: "12px 20px",
    borderRadius: 30,
    border: "none",
    background: "#FFD6A5",
    cursor: "pointer",
    fontWeight: "bold",
  },
  modeContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 15,
    marginTop: 20,
  },
  modeBtn: {
    padding: 15,
    borderRadius: 15,
    border: "none",
    background: "#FFD6A5",
    fontSize: "1rem",
    cursor: "pointer",
  },
  card: {
    background: "white",
    padding: 30,
    borderRadius: 20,
    margin: "20px auto",
    width: "80%",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
  },
  smallBtn: {
    padding: "8px 15px",
    borderRadius: 15,
    border: "none",
    background: "#FFD6A5",
    cursor: "pointer",
    margin: 5,
  },
  backBtn: {
    marginBottom: 20,
    background: "transparent",
    border: "none",
    cursor: "pointer",
    fontSize: "1rem",
  },
  row: { display: "flex", justifyContent: "center", gap: 10 },
  progressBar: {
    width: "80%",
    height: 10,
    background: "#eee",
    borderRadius: 10,
    margin: "0 auto 20px",
    overflow: "hidden",
  },

  progressFill: {
    height: "100%",
    background: "#FFD6A5",
    transition: "width 0.3s ease",
  },
  choiceBtn: {
    display: "block",
    width: "75%",
    margin: "12px auto",
    padding: 14,
    borderRadius: 18,
    border: "none",
    background: "#FFD6A5",
    cursor: "pointer",
    fontWeight: "bold",
    fontSize: "1rem",
    boxShadow: "0 4px 0 #e6b98c",
  },
};
